export default "__VITE_ASSET__4cb3a807__"